import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import FormUsedGameComponent from '../components/FormUsedGameComponent';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';
import { getProductImageFolder } from '../utils/productForm';
import { uploadProductImages } from '../utils/productImages';

const USED_PRODUCT_TYPE = 3;

var config = process.env;

class AddUsedGamePage extends Component {
    constructor() {
        super();
        this.state = { checked: false, role: 0, disabled: false };
    }

    async componentDidMount() {
        const role = await validateSession();
        this.setState({ checked: true, role });
    }

    handleChangeData = (value) => {
        this.setState({ disabled: true });
        // Las imágenes no van en el body: el backend sólo guarda datos del juego. Se suben al
        // bucket DESPUÉS, porque recién con la respuesta se conoce el código, que es la carpeta.
        const { images, ...payload } = value;
        const request = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'access-token': localStorage.getItem('token'),
            },
            body: JSON.stringify(payload),
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'used-games', request)
            .then((results) => results.json())
            .then((data) => {
                if (data.error > 0) {
                    alert(data.message);
                    this.setState({ disabled: false });
                    if (data.error === 1002) {
                        window.location.href = localStorage.getItem('homePageURL');
                    }
                    return;
                }
                const code = data.data && data.data.code;
                if (!code) {
                    // El usado quedó creado igual; sólo se pierden las imágenes. Se avisa en vez
                    // de redirigir en silencio haciendo creer que se subieron.
                    alert('El usado se registró, pero no se pudo determinar su código para subir las imágenes.');
                    navigateTo('/usedGames');
                    return;
                }
                const folder = getProductImageFolder(USED_PRODUCT_TYPE, code);
                uploadProductImages(folder, images, (pct) => this.setState({ uploadValue: pct }))
                    .then(() => navigateTo('/usedGames'))
                    .catch(() => {
                        // Mismo criterio: el alta ya está hecha, no se puede deshacer por una foto.
                        alert('El usado se registró, pero falló la subida de alguna imagen. Podés cargarlas desde Editar.');
                        navigateTo('/usedGames');
                    });
            });
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={22} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <HeaderComponent title="Usados" subtitle="Nuevo juego usado" />
                            <FormUsedGameComponent
                                onChangeData={this.handleChangeData}
                                disabled={this.state.disabled}
                                role={this.state.role}
                            />
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default AddUsedGamePage;
